export default function setMockCompany(){
    localStorage.setItem("compania", "Aeroméxico");
};
